export enum TextOptionEnum {
  BOLD = '*',
  ITALIC = '_',
  STROKE = '~',
  INLINE_CODE = '`',
  EMOJI = 'emoji',
  DYNAMIC_VALUE = 'dynamicValue',
}
